// extracted by mini-css-extract-plugin
export default {"headerContent":"Header_headerContent__cwM4T","tooltipWrapper":"Header_tooltipWrapper__E0g4g","tooltip":"Header_tooltip__fYI-o","infoIcon":"Header_infoIcon__UXUt8"};